var exports = {
  "Y9": "Header__cKmK4B",
  "dR": "TitleRow__ijViJ7",
  "hE": "Title__AOm2TR",
  "En": "Actions__vgeFFK",
  "W8": "Meta__IQaCH6",
  "Qi": "AuthorLink__VbguLb",
  "E": "OthersButton__fBWDgl",
  "LN": "Avatars__DWdZ6t",
  "_O": "AuthorLabel__Kt34ki",
  "dp": "ClosedBanner__Lcj6Df",
};

module.exports = exports;
